import { render, staticRenderFns } from "./BulkAddShopsComponent.vue?vue&type=template&id=5a13fe74&"
import script from "./BulkAddShopsComponent.vue?vue&type=script&lang=js&"
export * from "./BulkAddShopsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports